var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeacureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 39H0V0H39V39Z",
    stroke: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0C19.8504 0 20.2008 0.0761719 20.5207 0.220898L34.8639 6.30703C36.5397 7.01543 37.7889 8.66836 37.7813 10.6641C37.7432 18.2203 34.6354 32.0455 21.511 38.3297C20.2389 38.9391 18.7612 38.9391 17.4891 38.3297C4.36468 32.0455 1.25687 18.2203 1.21878 10.6641C1.21117 8.66836 2.46039 7.01543 4.13617 6.30703L18.4869 0.220898C18.7993 0.0761719 19.1496 0 19.5 0ZM19.5 5.08828V33.8812C30.0118 28.793 32.8377 17.5271 32.9063 10.7707L19.5 5.08828Z",
    fill: "#FFB02E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeacureIcon);
export default __webpack_public_path__ + "static/media/seacure-icon.dd66e29bf0ab78692a8f0f01fdb81ef0.svg";
export { ForwardRef as ReactComponent };